import { render, staticRenderFns } from "./SetLoginPassword.vue?vue&type=template&id=50dc2b2a&scoped=true"
import script from "./SetLoginPassword.vue?vue&type=script&lang=js"
export * from "./SetLoginPassword.vue?vue&type=script&lang=js"
import style0 from "./SetLoginPassword.vue?vue&type=style&index=0&id=50dc2b2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dc2b2a",
  null
  
)

export default component.exports